import { Text } from '@thanx/uikit/text'
import React from 'react'

type Props = {
  createdAt: string
}

const ListCardMeta: React.FC<Props> = React.memo(({ createdAt }) => (
  <div className="d-flex align-items-center">
    <Text.BodyText4 className="m-0 grey-70">
      Created: {new Date(createdAt).toLocaleDateString()}
    </Text.BodyText4>
  </div>
))

ListCardMeta.displayName = 'ListCardMeta'

export default ListCardMeta
